import { gql } from '@apollo/client';

import {
  CardFragment,
  CardFragmentDoc,
} from '../../fragments/CardFragment.generated';
import { generateQueryHook } from '../../utils';

import {
  CardQueryResult,
  CardQueryVariables,
  useCardQuery,
} from './useCardById.generated';

gql`
  query Card($id: ID!, $consumer: Boolean) {
    card(id: $id, consumer: $consumer) {
      ...CardFragment
    }
  }
  ${CardFragmentDoc}
`;

interface HookDataToOutputReturn {
  card?: CardFragment;
}

const DEFAULT_RETURN: HookDataToOutputReturn = {
  card: undefined,
};

const hookDataToOutput = (
  data?: CardQueryResult | null,
): HookDataToOutputReturn => {
  const toReturn: HookDataToOutputReturn = {
    card: undefined,
  };

  if (data?.card) {
    toReturn.card = data.card;
  }

  return toReturn;
};

const useCardById = generateQueryHook<
  CardQueryResult,
  CardQueryVariables,
  HookDataToOutputReturn
>(hookDataToOutput, useCardQuery, DEFAULT_RETURN);

export default useCardById;
